import { render, staticRenderFns } from "./ExoticBadge.vue?vue&type=template&id=2b529b78&"
import script from "./ExoticBadge.vue?vue&type=script&lang=js&"
export * from "./ExoticBadge.vue?vue&type=script&lang=js&"
import style0 from "./ExoticBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports